import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { mgcIconTransfer3Regular } from '@sb/mgc-icons/mgcIcon-transfer_3_regular.icon';
import { IconComponent, IconRegistry } from '@sb/ui/icon';

@Component({
  selector: 'sb-profile-clock-switch-item',
  imports: [TranslatePipe, RouterModule, IconComponent],
  template: `
    <a class="flex w-full px-2">
      <div
        [routerLink]="['', { outlets: { modal: ['clock-switch'] } }]"
        class="flex flex-1 items-center gap-3 rounded bg-brand-subtle px-3.5 py-4 text-xl font-bold text-brand hover:bg-brand/15 xl:px-1.5 xl:py-2 xl:text-lg xl:font-semibold"
      >
        <sb-icon class="h-5 w-5 xl:h-4 xl:w-4" name="transfer-3-regular" />
        {{ 'Switch shift' | translate }}
      </div>
    </a>
  `,
})
export class SBProfileClockSwitchItemComponent {
  constructor() {
    inject(IconRegistry).registerIcons([mgcIconTransfer3Regular]);
  }
}
